export const PERMISSIONS = {
    LIST_VERSIONS: 'privacy-api.list-privacy-versions',
    READ_VERSIONS: 'privacy-api.read-privacy-versions',
    EDIT_VERSIONS: 'privacy-api.edit-version',
    ENABLE_ACTIVATE_VERSION: 'privacy-api.enable-activate-version',
    ENABLE_UPLOAD_PRIVACY_FILES: 'privacy-api.enable-upload-privacy-files',
    ENABLE_DOWNLOAD_PRIVACY_FILES: 'privacy-api.enable-download-privacy-files',
    DELETE_PRIVACY_FILES: 'privacy-api.delete-privacy-files',
};
export function hasPermission( permission, auth ) {
    const userPermissions = auth?.state?.claims?.permissions;
    if ( !userPermissions ) {
        return false;
    }

    const [ app, key ] = permission.split( '.', 2 );

    const appPermissions = userPermissions[ app ];

    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }

    return appPermissions.includes( key );
}
